import * as Yup from 'yup';

export const applicantDetailsSchema = Yup.object({
  first_name: Yup.string().required('Required field'),
  last_name: Yup.string().required('Required field'),
  address_lines: Yup.string(),
  city: Yup.string().required('Required field'),
  state: Yup.string().required('Required field'),
  zip_code: Yup.string()
    .required('Required field')
    .test('len', 'Must be exactly 5 characters', val => val.length === 5),
  cell_phone_number: Yup.string().required('Required field'),
  home_phone_number: Yup.string(),
  date_of_birth: Yup.string().required('Required field'),
  social_security_number: Yup.string()
    .required('Required field')
    .test('len', 'Must be exactly 10 characters', val => val.length === 10),
  email_address: Yup.string().required('Required field').email(),
});
